<template>
  <span id="reject-extension-dialog">
    <el-button
      id="btn-reject-extension"
      type="success"
      plain
      @click="dialogVisible = true"
      class="deny-btn"
      size="mini"
    >
      <img src="@/assets/svg/Deny-Logo.svg" alt="Deny-Logo" />
      {{$t('extensionRequest.reject')}}
    </el-button>
    <el-dialog
      id="dialog-reject-extension"
      :close-on-click-modal="false"
      v-on:open="handleOpen"
      :title="$t('extensionRequest.rejectExtensions')"
      :visible.sync="dialogVisible"
      width="40%"
      class="dialog-with-cols"
      append-to-body
    >
      <el-form :model="form" label-position="right" size="mini" class="search-section-form">
        <el-row :gutter="10">
          <el-col>
            <el-form-item :label="$t('extensionRequest.rejectionReason')">
              <el-select v-model="form.reasonKey" size="mini" @change="updateInputMessage">
                <el-option
                  v-for="item in rejectionReasons"
                  :key="item.key"
                  :label="item.name"
                  :value="item.key"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col>
            <el-form-item :label="$t('extensionRequest.rejectionMessage')">
              <el-input
                v-model="form.message"
                clearable
                maxlength="255"
                :disabled="!messageEditable"
                :aria-disabled="!messageEditable"
                type="textarea"
                :rows="3"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <el-row :gutter="10">
        <el-col>
          <label class="margin-bottom-small-list">{{ $t('extensionRequest.rejectConfirmation') }}</label>
        </el-col>
      </el-row>

      <div id="reject-dialog-footer" slot="footer" class="dialog-footer form-vertical-item flex-reverse-direction">
        <el-button
          type="primary"
          id="form-reject-button"
          @click="handleReject()"
          size="mini"
        >{{ $t('extensionRequest.reject') }}</el-button>
        <el-button
          id="form-refresh-button"
          @click="dialogVisible = false"
          size="mini"
        >{{ $t('common.cancel') }}</el-button>
      </div>
    </el-dialog>
  </span>
</template>

<script>
import { mapGetters } from 'vuex';
import constants from '@/utils/constants';

export default {
  computed: {
    ...mapGetters(['extensionRequest'])
  },
  props: {
    shipDate: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      rejectionReasons: [],
      dialogVisible: false,
      messageEditable: false,
      form: {
        reasonKey: null,
        message: ''
      }
    };
  },
  methods: {
    handleOpen() {
      this.getRejectionReasons();
    },
    async handleReject() {
      const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
      try {
        const response = await this.$store.dispatch('extensionRequest/reject', {
          shipDate: this.shipDate,
          message: this.form.message
        });
        this.$message.success(response.message);
      } finally {
        await this.$store.dispatch('extensionRequest/search', {});
        loading.close();
        this.dialogVisible = false;
        this.$emit('closeDialog');
      }
    },
    getRejectionReasons() {
      const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
      return this.$store
        .dispatch('extensionRequest/getRejectionReasons')
        .then((response) => {
          this.rejectionReasons = response.data;
          const defaultReason = this.rejectionReasons.find(
            reason => reason.default
          );
          if (defaultReason) {
            this.form.reasonKey = defaultReason.key;
            this.form.message = defaultReason.message;
            this.messageEditable = defaultReason.messageEditable;
          }
          loading.close();
        })
        .catch((error) => {
          this.$message.error(error.response.message);
          loading.close();
        });
    },
    updateInputMessage() {
      const selectedReason = this.rejectionReasons.find(
        reason => reason.key === this.form.reasonKey
      );
      this.form.message = selectedReason.message;
      this.messageEditable = selectedReason.messageEditable;
    }
  }
};
</script>
